// extracted by mini-css-extract-plugin
export default {"reset":"Link_reset__OvXVs"};